export const PinnedMessageTestIds = {
  fieldPinnedmessage: 'field_pinnedmessage',
  fieldMessageContent: 'field_message_content'
} as const;
